
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { Purchase } from "@/lib/purchases";

interface ActionButtonsProps {
  purchase: Purchase | null;
  courseId: string | null;
}

const ActionButtons = ({ purchase, courseId }: ActionButtonsProps) => {
  const isPaymentCompleted = purchase && (
    purchase.payment_status === "completed" || purchase.status === "completed"
  );

  return (
    <div className="text-center space-y-4">
      {courseId && isPaymentCompleted ? (
        <Button asChild className="bg-kaija-accent hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
          <Link to={`/learner/course/${courseId}`} className="flex items-center">
            Mine kursuse juurde <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      ) : (
        <Button asChild className="bg-kaija-accent hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
          <Link to="/my-courses" className="flex items-center">
            Mine minu kursuste juurde <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      )}

      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-4">
        <Button asChild variant="outline">
          <Link to="/courses" className="flex items-center">
            Vaata teisi kursuseid
          </Link>
        </Button>

        <Button asChild variant="outline">
          <Link to="/profile?tab=purchases" className="flex items-center">
            <ShoppingBag className="mr-2 h-4 w-4" />
            Vaata ostuajalugu
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;
